import { FooterProps } from './Footer.types';
import * as S from './Footer.styles';

const Footer = ({ children }: FooterProps): JSX.Element => <S.Container>{children}</S.Container>;

export default Footer;
